import { List } from "immutable";
import { any, async, fromJSX, nothing, stateful } from "widgets-for-react";
import { previousOrDefault } from "../../../custom_api/api_utils";
import { noOp } from "../../../custom_utils/helpers";
import { BooksBlock } from "../books_block";
import { initialThemakiezerBlockState } from "./ThemakiezerBlockState";
export const ThemakiezerBlock = (props)=>stateful()((state)=>any({
            key: `ThemakiezerBlock-${props.embedId}`
        })([
            state.books.kind == 'loaded' ? fromJSX(()=>BooksBlock({
                    ...props,
                    kind: 'books',
                    books: bookProps(state.books)
                })) : nothing(),
            async(nothing, {
                key: 'ThemakiezerLoader'
            })(state.books).map((resultUpdater)=>(s0)=>({
                        ...s0,
                        books: resultUpdater(s0.books)
                    }))
        ]).map((a)=>a(state)))(initialThemakiezerBlockState(props)).run(noOp);
const bookProps = (items)=>List(previousOrDefault(items, [])).map((b)=>({
            title: b.title,
            author: b.authors[0],
            imageUrl: b.image.Thumbnail2x || b.image.Thumbnail || '',
            imageAlt: `Kaft van ${b.title} door ${b.authors[0]}`,
            url: b.originalUrl
        })).toList();
